import { render } from "./BatchesWaitingBalanceTotalsContainer.vue?vue&type=template&id=7feead4a"
import script from "./BatchesWaitingBalanceTotalsContainer.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingBalanceTotalsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__